import * as Sentry from '@sentry/react';

const ADS_URL =
    'https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js';

/**
 * Probes whether ads are blocked and reports the result to `callback`.
 *
 * The result is also kept as the global Sentry tag `ad_blocker` (`yes|no`),
 * so every later error carries it without a second probe. A failed request
 * (offline, network filter) reads as blocked, so treat the tag as a hint.
 *
 * @param {(adsBlocked: boolean) => void} callback
 */
export const checkAdBlockers = (callback) => {
    const xhr = new XMLHttpRequest();

    xhr.onreadystatechange = function () {
        if (xhr.readyState === XMLHttpRequest.DONE) {
            const adsBlocked = xhr.status === 0 || xhr.responseURL !== ADS_URL;

            Sentry.setTag('ad_blocker', adsBlocked ? 'yes' : 'no');
            callback(adsBlocked);
        }
    };

    xhr.open('HEAD', ADS_URL, true);
    xhr.setRequestHeader('Cache-Control', 'no-cache');
    xhr.send(null);
};
